// Early bird offer: partner-code runners (e.g. McDonald's) pre-commit to a
// discounted annual price and pay nothing until their code ends.
//
// CRM links to /offers?offer=early_bird. Login and email verification both
// redirect to a bare /offers, so the flag is kept in sessionStorage from the
// first page load until the runner subscribes, logs out, changes plan, or
// leaves via "Go to my account". It belongs to the first account that signs
// in after the link is opened; another account in the same tab drops it.

const OFFER_PARAM = 'offer';
export const EARLY_BIRD_OFFER = 'early_bird';
const STORAGE_KEY = 'urunn_offer';
const OWNER_KEY = 'urunn_offer_uid';

// The server charges straight away when under an hour of free access is left.
// Show "pay today" from two hours out, so the page never promises £0 and charges.
export const EARLY_BIRD_MIN_FREE_LEAD_MS = 2 * 60 * 60 * 1000;

/** Call once on app start: remembers the offer from the landing URL. */
export const rememberEarlyBirdOffer = (): void => {
  try {
    const offer = new URLSearchParams(window.location.search).get(OFFER_PARAM);
    if (offer === EARLY_BIRD_OFFER) sessionStorage.setItem(STORAGE_KEY, offer);
  } catch {
    // Storage blocked (private mode etc.): the URL param still works on /offers.
  }
};

/** True when this visit came from an early bird link. */
export const isEarlyBirdOffer = (): boolean => {
  if (new URLSearchParams(window.location.search).get(OFFER_PARAM) === EARLY_BIRD_OFFER) return true;
  try {
    return sessionStorage.getItem(STORAGE_KEY) === EARLY_BIRD_OFFER;
  } catch {
    return false;
  }
};

export const clearEarlyBirdOffer = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
    sessionStorage.removeItem(OWNER_KEY);
  } catch {
    // Nothing to clear.
  }
};

/**
 * Call on every sign-in. The first account to sign in after the link was
 * opened owns the offer; a different account (e.g. after a session expired
 * without logout) drops it.
 */
export const bindEarlyBirdOfferToUser = (uid: string): void => {
  try {
    if (sessionStorage.getItem(STORAGE_KEY) !== EARLY_BIRD_OFFER) return;
    const owner = sessionStorage.getItem(OWNER_KEY);
    if (!owner) sessionStorage.setItem(OWNER_KEY, uid);
    else if (owner !== uid) clearEarlyBirdOffer();
  } catch {
    // Storage blocked: nothing is remembered, so nothing can leak.
  }
};
